import React, {
  forwardRef,
  MouseEventHandler,
  ReactNode,
  Ref,
  useCallback,
} from "react";

import classnames from "classnames";

import { StyledOption } from "./Styles";

export interface IOptionItemProps {
  /** Value of option */
  id: string | number;
  /** Label of option */
  name: string;
  /** Content for tooltip */
  tooltip?: string;
  /** Additional info right-side of name */
  additionalInfo?: string;
  /** image url for Avatar or MultiAvatar */
  image?: string | string[];
  /** Hex color for label */
  color?: string;
  /** Color for chip label */
  chipColor?: string;
  /** Value of mixed */
  mixed?: boolean;
}

interface IAdditionalOptionItemProps {
  /** Value of option */
  id?: string | number;
  /** Label of option */
  name: string;
  /** Content for tooltip */
  tooltip?: string;
  /** Hovered state */
  hover?: boolean;
  /** Class name of option */
  className?: string;
  /** Render option function */
  renderOption?: ReactNode;
  /** On mouse enter callback */
  onMouseEnter?: (e: string | number | undefined) => void;
  /** On mouse click */
  onClick?: MouseEventHandler<HTMLLIElement>;
}

export const Option = forwardRef(
  (
    {
      id,
      name,
      tooltip = "",
      hover,
      className,
      renderOption,
      onMouseEnter,
      onClick = () => null,
    }: IAdditionalOptionItemProps,
    ref: Ref<HTMLLIElement>
  ) => {
    const handleOnMouseEnter = useCallback(() => {
      if (onMouseEnter) {
        onMouseEnter(id);
      }
    }, [onMouseEnter, id]);

    return (
      <StyledOption
        ref={hover ? ref : null}
        title={tooltip ? tooltip : name}
        onMouseEnter={handleOnMouseEnter}
        onTouchStart={handleOnMouseEnter}
        className={classnames("c-option", className)}
        hover={hover}
        onClick={onClick}
      >
        {renderOption ? renderOption : name}
      </StyledOption>
    );
  }
);

Option.displayName = "Option";
